/* V2 presentation: keeps the tested product/cart and approved video components intact. */
(() => {
 'use strict';
 customElements.whenDefined('vl-borse-product').then(() => {
  const Component = customElements.get('vl-borse-product');
  if (Component.prototype.vbReferenceReady) return;
  const previousUpdate = Component.prototype.updateVariant;
  Component.prototype.updateVariant = function (...args) {
   previousUpdate.apply(this, args);
   if (!this.classList.contains('vl-borse--reference')) return;
   const variant = this.selectedVariant();
   if (!variant) return;
   const badge = this.querySelector('[data-main-discount]');
   if (badge && !badge.hidden) badge.textContent = `RISPARMIA IL ${Math.round((variant.compare - variant.price) * 100 / variant.compare)}%`;
   const stock = this.querySelector('[data-vb-stock]');
   const limited = Boolean(variant.tracked) && variant.policy !== 'continue' && variant.inventory > 0 && variant.inventory <= 10;
   if (stock) { stock.textContent = !variant.available ? 'Non disponibile' : limited ? `Ultimi ${variant.inventory} pezzi` : 'Disponibile online'; stock.closest('details').classList.toggle('is-limited', limited); }
  };
  Component.prototype.vbReferenceReady = true;
  document.querySelectorAll('vl-borse-product.vl-borse--reference').forEach(root => { if (root.form) root.updateVariant(false); });
 });
 document.addEventListener('change', event => {
  const select = event.target.closest('.vl-borse--reference [data-vb-form="related"] select');
  if (!select) return;
  const option = select.selectedOptions[0];
  const card = select.closest('.vl-borse__related-item');
  const price = card.querySelector('[data-related-price]');
  const compare = card.querySelector('[data-related-compare]');
  if (price) price.textContent = option.dataset.price || '';
  if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
 });
})();
